import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class Sponsor extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Sponsor';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            image: null,
            order: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.HomeFeature) {
    //         data.HomeFeature = new models.api.HomeFeature(data.HomeFeature)
    //     }
    //     return data
    // }
}

const servicePath = 'f-sponsor';
const servicePlugin = makeServicePlugin({
    Model: Sponsor,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin